import React from "react";
import "./index.less";
import RobotImg from "imgs/robot.png";
import LogoImg from "imgs/logo.svg";

import Header from "../header";

export default function App({ headerImg, children }) {
    return (
        <div className="layout-wrap">
            <Header />
            {/* <img className="layout-logo" src={LogoImg} /> */}
            <div className="layout-home-btn-wrap">
                {/* <a className="layout-home-btn" href="https://dfmc.hotjob.cn/wt/DFMC/web/index/campus">首页</a> */}
                <a className="layout-home-btn" href="./index.html">首页</a>
            </div>
            <div className="layout-box">
                <div className="layout-header">
                    <img src={headerImg} />
                </div>
                <div className="layout-content">{children}</div>
            </div>
            <a className="layout-float-btn" href="./hyacinth.html">
                <img src={RobotImg} />
            </a>
        </div>
    )
}